import React, { useEffect, useState } from "react";
import { CaretIcon, ModalCloseButton, Select } from "react-responsive-select";
import "react-responsive-select/dist/react-responsive-select.css";
import "./inputItem.css";
import { IoEyeOffOutline } from "react-icons/io5";
import { EyeIcon } from "@heroicons/react/24/outline";

//Textfield
interface TextfieldProps {
  title: string;
  value: string;
  placeholderValue?: string;
  isEditable: boolean;
  isSelectField: boolean;
  isSecretField?: boolean;
  withEyeClosed?: boolean;
  allowFreeText?: boolean; // Nouvelle prop pour permettre la saisie libre
  onSend?: (value: string) => void;
  onChange: (value: string) => void;
  selectionList?: { [key: string]: string };
}

const InputTextfield: React.FC<TextfieldProps> = ({
  title,
  value,
  placeholderValue,
  isEditable,
  isSelectField,
  isSecretField,
  withEyeClosed,
  allowFreeText = false,
  onSend,
  onChange,
  selectionList,
}) => {
  // Vérifiez si isSelectField est vrai et si selectionList est défini
  //   if (isSelectField && !selectionList) {
  //     throw new Error("selectionList est requis quand isSelectField est vrai");
  //   }
  const [currentValue, setCurrentValue] = useState(value);
  const [placeholder, setPlaceholder] = useState<string>(
    placeholderValue ?? "",
  );
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const withEyeClosedValue = withEyeClosed || false;

  const handleToggle = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    setCurrentValue(value);
    if (onSend) {
      onSend(value);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className="flex flex-col items-center justify-center mb-4 w-full">
      <label className="block mb-2 w-full">{title}</label>

      {!isSelectField ? (
        isEditable ? (
          !isSecretField ? (
            <input
              type="text"
              placeholder={`${placeholder}`}
              className="p-2 w-full border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585] focus:outline-none focus:ring-0 focus:border-transparent"
              value={currentValue}
              onChange={handleChange}
            />
          ) : (
            <div className="flex flex-row w-full h-full gap-2 justify-between items-center border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585]">
              <input
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                className="p-2 w-full border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585] focus:outline-none focus:ring-0 focus:border-transparent"
                value={currentValue}
                onChange={handleChange}
              />
              {withEyeClosedValue ? (
                showPassword ? (
                  <IoEyeOffOutline
                    className="w-5 h-5 mr-3 cursor-pointer"
                    aria-hidden={"true"}
                    onClick={handleToggle}
                  />
                ) : (
                  <EyeIcon
                    className="w-5 h-5 mr-3 cursor-pointer"
                    aria-hidden={"true"}
                    onClick={handleToggle}
                  />
                )
              ) : null}
            </div>
          )
        ) : (
          <div
            className={`w-60 h-10 rounded-md border border-[#EEEEEE]`}
            style={{ outline: "none" }}
          >
            <div className="text-center text-[#757575] text-x3 font-semibold font-['Open Sans'] leading-3">
              {currentValue}
            </div>
          </div>
        )
      ) : allowFreeText ? (
        // Input avec datalist pour permettre la saisie libre
        <div className="relative w-full">
          <input
            list={`${title}-options`}
            className="p-2 w-full border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585] focus:outline-none focus:ring-0 focus:border-transparent"
            value={currentValue}
            onChange={(e) => {
              setCurrentValue(e.target.value);
              onChange(e.target.value);
            }}
            placeholder={placeholder}
          />
          <datalist id={`${title}-options`}>
            {placeholderValue != undefined && (
              <option value="" disabled>
                {`${placeholder}`}
              </option>
            )}
            {Object.entries(selectionList || {}).map(([key, value]) => (
              <option key={key} value={value}>
                {key}
              </option>
            ))}
          </datalist>
        </div>
      ) : (
        // Select pur pour les dropdowns classiques
        <select
          className="p-2 w-full border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585] focus:outline-none focus:ring-0 focus:border-transparent"
          value={currentValue}
          onChange={(e) => {
            setCurrentValue(e.target.value);
            onChange(e.target.value);
          }}
        >
          {placeholderValue != undefined && (
            <option value="" disabled>
              {`${placeholder}`}
            </option>
          )}
          {Object.entries(selectionList || {}).map(([key, value]) => (
            <option key={key} value={value}>
              {key}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default InputTextfield;
//endTextfield

//Split schoolClass function
export function parseSchoolClass(schoolClass: string) {
  if (!schoolClass.includes("_")) {
    console.log(
      'Invalid input! The input string must contain a "_" character.',
    );
    const level = "";
    const serie = "";
    return { level, serie };
  }
  let [level, serie] = schoolClass.split("_");
  level = level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
  return { level, serie };
}
//end Split schoolClass function

//getInitials function
export function getInitials(str1: string, str2: string): string {
  let lettre1 = str1.charAt(0).toUpperCase();
  let lettre2 = str2.charAt(0).toUpperCase();
  return lettre1 + lettre2;
}
//end getInitials function

//SelectField
const TextfieldChoising: React.FC = () => {
  const [currentValue, setCurrentValue] = useState("");

  return (
    <div className="flex flex-col h-screen w-full relative bg-[#FCFCFC] justify-center space-y-10 rounded-lg border border-slate-50">
      <form>
        <Select
          name="carType1"
          modalCloseButton={<ModalCloseButton />}
          options={[
            { value: "null", text: "Any" },
            { value: "subaru", text: "Subaru" },
          ]}
          caretIcon={<CaretIcon />}
          prefix="Car1: "
          selectedValue="subaru"
          onChange={(newValue) => console.log("onChange", newValue)}
          onSubmit={() => console.log("onSubmit")}
        />
      </form>
    </div>
  );
};

{
  /* <form className="fix h-full p-2 w-full color-[#EDEDED] border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585] focus:outline-none focus:ring-0 focus:border-transparent">
  <Select
    name="p-2 w-full border border-[#EDEDED] rounded bg-[#EDEDED] text-6x1 text-[#858585] focus:outline-none focus:ring-0 focus:border-transparent"
    modalCloseButton={<ModalCloseButton />}
    options={Object.entries(selectionList || {}).map(([key, value]) => ({ value, text: key }))}
    caretIcon={<CaretIcon />}
    selectedValue={currentValue}
    onChange={(value) => {
      setCurrentValue(value);
      onChange(value);
    }}
    onSubmit={(value) => {
      setCurrentValue(value);
      onChange(value);
    }}
  />
</form>  */
}
